import React from 'react'
import { Paper, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const MIN_STATISTIC_CARD_WIDTH = 260

interface StyleProps {
  size?: 'small' | 'large'
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  cardContainer: {
    padding: props.size === 'small' ? theme.spacing(2) : theme.spacing(3),
    height: '100%',
    alignContent: 'center',
  },
  title: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    marginBottom: theme.spacing(1),
  },
  value: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.1px',
  },
}))

interface StatisticCardProps {
  icon: React.ReactElement
  value: string
  title: string
  size?: 'small' | 'large'
}

/**
 * Statistic card component displays single card for statistic inside dashboard.
 * @param - icon as React element for specific icon
 * @param - statistic card value as string
 * @param - statistic card title
 */
export const StatisticCard: React.FC<StatisticCardProps> = ({ icon, value, title, size }) => {
  const { classes } = useStyles({ size })

  return (
    <Paper className={classes.cardContainer}>
      <Stack direction="row" alignItems="center" spacing={2}>
        {icon}
        <Stack justifyContent="space-between">
          <Typography variant="subtitle2" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="h2" className={classes.value}>
            {value}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  )
}
